import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.taskStatuses.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.taskStatuses.actionsLoading;
export const getItems = (state:RootState) => state.taskStatuses.items;
export const getDropDownItems = (state:RootState) => state.taskStatuses.dropDownItems;
export const getDropDownItemsLoading = (state:RootState) => state.taskStatuses.dropDownLoading;
export const getItemsCount = (state:RootState) => state.taskStatuses.itemsCount;
export const getItemForEdit = (state:RootState) => state.taskStatuses.itemForEdit;
export const getError = (state:RootState) => state.taskStatuses.error;
export const getErrorAction = (state:RootState) => state.taskStatuses.errorAction;
export const validationErrors = (state:RootState) => state.taskStatuses.validationErrors;